'use client';
import { useLayoutEffect, useState } from 'react';

const screenSizes = ['mobile', 'desktop'] as const;

export function useScreenSize() {
  const [screen, setScreen] = useState<(typeof screenSizes)[number]>('desktop');

  useLayoutEffect(() => {
    // These match tailwind config. Changing values in one place should replace both.
    const mobileMql = window.matchMedia('(max-width: 480px)');
    const desktopMql = window.matchMedia('(min-width: 1025px)');

    const computeScreen = (): (typeof screenSizes)[number] => {
      if (mobileMql.matches) return 'mobile';
      if (desktopMql.matches) return 'desktop';
      return 'desktop';
    };

    const handler = (): void => {
      setScreen(computeScreen());
    };

    setScreen(computeScreen());

    const mediaQueryLists = [mobileMql, desktopMql];

    mediaQueryLists.forEach((mql) => mql.addEventListener('change', handler));

    return (): void => {
      mediaQueryLists.forEach((mql) =>
        mql.removeEventListener('change', handler)
      );
    };
  }, []);

  return {
    isMobile: screen === 'mobile',
    isDesktop: screen === 'desktop',
    notMountedScreen: !screen,
  };
}
